import { render, staticRenderFns } from "./KeyboardNavigation.vue?vue&type=template&id=7af1a547&scoped=true&"
import script from "./KeyboardNavigation.vue?vue&type=script&lang=js&"
export * from "./KeyboardNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1a547",
  null
  
)

export default component.exports